<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  created() {
    if (this.$cookie.get('ONLINEFLAG') === "ONLINE") {
      this.$router.push(this.$startPath);
    } else {
      // this.$router.push("/TourManagement");
      ///Login
      //this.$router.push("/Main");
    }
  }
}
</script>
